<template>
    <div>
        <el-dialog
            title="用车结束"
            :visible.sync="dialogShow"
            width="50%"
            :fullscreen="dialogFull"
            top="30px"
            :destroy-on-close="true"
            before-close="handleClose"
            :close-on-click-modal="false"
            append-to-body
            :modal-append-to-body="false">
            <template slot="title">
                <div class="avue-crud__dialog__header">
                        <span class="el-dialog__title">
                            用车结束
                        </span>
                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                        
                </div>
      </template>
      <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
            <avue-form 
                :option="option"
                v-model="form"
                ref="form"
                v-if="dialogShow"
                @submit="formSubmit"
                @error="formError">
                <template slot="areaId">
                    <el-select
                            v-model="form.areaId"
                            placeholder="请选择需求区域"
                            ref="addConnectSelect"
                            >
                            <el-option :value="form.areaId" show-all-levels :label="form.areaName">
                                <el-tree
                                    node-key="id"
                                    :data="treeFormAreaData"
                                    :props="treeProps"
                                    :load="editAreaLazyLoadTree"
                                    lazy
                                    @node-click="editAreaNodeTreeClick_"
                                >
                                </el-tree>
                            </el-option>
                    </el-select>
                </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="remarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="attachList">
                    <div>
                        <vupload :fileList.sync="form.attachList"></vupload>
                    </div>
                </template>
                <template slot="endMileage">
                        <el-input  @input="workTimeInput" @blur="blurEndMile" maxlength="10" placeholder="里程数 (千米)" :value="form.endMileage">
                             <el-button slot="append" >千米</el-button>
                        </el-input>
                </template>
                <!-- <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
                </template> -->
            </avue-form>
      </div>
      <template slot="footer"> 
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {getUseMileage} from "@/api/crmedical/car/car-record/index";
import {
    endOption,
    omitNumber
} from "./option.js";
import { 
        getRemarkList,
        start,
        finish,
        lazyAreaTree
 } from "@/api/gateservice/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{
                orderId:'',
                attachList:[],
                areaId:'',
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            treeProps: {//报修表单 --需求区域树的配置
                //标题
                label: 'name',
                //值
                value: 'id',
                //子节点
                children: 'zones',
                //是否叶子节点
                isLeaf: 'hasChildren',
                //本节点类型key值
                objectType: 'id',
                //本节点类型名
                objectTypeName: 'name',
            },
            data:{},
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            option:endOption
        }
    },
    created(){
        
    },
    methods:{
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        workTimeInput(e){
            this.form.endMileage = e.slice(0,10);
            // this.form.endMileage = omitNumber(e);
        },
        blurEndMile(e){
            getUseMileage({orderId:this.data.orderId,endMileage:this.form.endMileage}).then((res)=>{
                this.form.useMileage = res.data;
            }).catch((e)=>{
                this.form.useMileage = 0;
                wx.showToast({
                    title: e,
                    icon: 'none',
                    duration: 2000
                })
                return;
            });
        },
        openDialog(data){
            this.dialogShow = true;
            console.log("openDialog")
            this.data = data;
            this.form = {
                orderId:data.orderId,
                attachList:[],
            
            }
            console.log(this.$refs.remarkModel)
            getRemarkList({orderId:data.orderId,actionType:data.actionType}).then(res=>{
                this.$refs.remarkModel.setRemarkList(res.data);

            })
           
        },
        closeDialog(){
            this.dialogShow = false;
        },
        
        formError(done){
            done()
        },
        formSubmit1(){
      this.$refs.form.submit();
    },
        formSubmit(form,done){
             // 业务数据
            let temObj = {endMileage:form.endMileage,endSite:form.endSite,endTime:form.endTime,useMileage:form.useMileage}
            form.moduleJson= JSON.stringify(temObj)
            finish(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})
                
                this.dialogShow = false;
                done()
            }).catch(err=>{
                
                
                done()
            })
        },
        
    }
}
</script>
